export default "__VITE_ASSET__FVB2jDgW__"